export default "__VITE_ASSET__CeImME_H__"